import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const QuoteCtx = createContext(null);

export function QuoteProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("mk_quote")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("mk_quote", JSON.stringify(items));
  }, [items]);

  const add = (p) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.id === p.id);
      if (ex) return prev.map((i) => (i.id === p.id ? { ...i, qty: i.qty + 1 } : i));
      return [...prev, { id: p.id, slug: p.slug, name: p.name, image: p.image, division: p.division, category: p.category, qty: 1 }];
    });
    toast.success("Added to quote list", { description: p.name });
  };

  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const setQty = (id, qty) =>
    setItems((prev) => prev.map((i) => (i.id === id ? { ...i, qty: Math.max(1, qty) } : i)));
  const clear = () => setItems([]);

  const count = items.reduce((a, i) => a + i.qty, 0);
  const value = useMemo(
    () => ({ items, add, remove, setQty, clear, count, open, setOpen }),
    [items, open, count]
  );
  return <QuoteCtx.Provider value={value}>{children}</QuoteCtx.Provider>;
}

export const useQuote = () => useContext(QuoteCtx);
